import {DetailsPageComponents} from '@stencil/omniture-analytics/src/constants/details';
import useOmnitureLoaded from '@stencil/omniture-analytics/src/hooks/useOmnitureLoaded';

// Components
import HomeStaySpacesItemList from './HomeStaySpacesItemList/HomeStaySpacesItemList';

import * as S from './HomeStaySpaces.styles';
import {getPrivateSpaceSlide} from './utility';

//Types
import {PrivateSpace, SharedSpaces} from '@stencil/hotels-cg-reducer/src/details/types';

interface HomeStaySpacesPropsUI {
  sharedSpaces: SharedSpaces[];
  privateSpaces: PrivateSpace[];
  handlerOnClickRoomCard: (arg1, arg2) => void;
  propertyLayoutTitleText: string;
  roomType: string;
}

const HomeStaySpaces = ({
  sharedSpaces = [],
  privateSpaces = [],
  handlerOnClickRoomCard = () => {},
  propertyLayoutTitleText = '',
  roomType = '',
}: HomeStaySpacesPropsUI) => {
  useOmnitureLoaded(DetailsPageComponents.propertyLayout);
  const {maxPrivatLength, maxSharedLength} = getPrivateSpaceSlide({
    privateSpaces,
    sharedSpaces,
  });

  return (
    <S.HomeStaySpacesWrapper data-testid="home-stay-spaces-wrapper">
      <S.HomeStaySpacesInnerWrapper>
        <S.HomeStaySpacesHeaderWrapper>
          <p className="headerText">Property Layout</p>
          <p className="descText">
            <span className="roomText">{propertyLayoutTitleText}</span>
          </p>
        </S.HomeStaySpacesHeaderWrapper>
        <S.HomeStaySpacesContentWrapper>
          {Boolean(privateSpaces?.length) && (
            <S.SpacesItemListWrapper isPrivateSpace={true} width={maxPrivatLength + 0.5}>
              <p className="spaceItemHeader">{`${roomType.toUpperCase()} (${privateSpaces?.length})`}</p>
              <HomeStaySpacesItemList
                spaceList={privateSpaces}
                isPrivateSpace
                sharedSpacesLength={sharedSpaces?.length}
                handlerOnClickRoomCard={handlerOnClickRoomCard}
              />
            </S.SpacesItemListWrapper>
          )}
          {Boolean(sharedSpaces?.length) && (
            <S.SpacesItemListWrapper isPrivateSpace={false} width={maxSharedLength}>
              <p className="spaceItemHeader">{`SHARED SPACES (${sharedSpaces?.length})`}</p>
              <HomeStaySpacesItemList
                spaceList={sharedSpaces}
                handlerOnClickRoomCard={handlerOnClickRoomCard}
              />
            </S.SpacesItemListWrapper>
          )}
        </S.HomeStaySpacesContentWrapper>
      </S.HomeStaySpacesInnerWrapper>
    </S.HomeStaySpacesWrapper>
  );
};

export default HomeStaySpaces;
